module.exports = __webpack_public_path__ + "img/health-status-good.76ad5227.svg";